const IAB_VENDOR_ID = '1139';

const getCleverPushService = () => window.UC_UI?.getServicesBaseInfo().find((service) => service.name && ((service.name || '').toLowerCase().indexOf('cleverpush') > -1));

const initUserCentrics = (subscriptionManager) => {
  let serviceEnabled = false;
  let cpService = getCleverPushService();
  if (cpService) {
    serviceEnabled = cpService.consent.status;
  }

  window.__tcfapi('addEventListener', 2, (success) => {
    if (!success) {
      return;
    }

    cpService = getCleverPushService();
    if (!cpService) {
      return;
    }

    const serviceEnabledNew = cpService.consent.status;
    if (serviceEnabledNew === serviceEnabled) {
      return;
    }

    serviceEnabled = serviceEnabledNew;
    if (!serviceEnabled) {
      subscriptionManager.unsubscribe(true);
    }
  });
};

// https://help.consentmanager.net/books/cmp/page/javascript-api
const initConsentManager = (subscriptionManager) => {
  let serviceEnabled = false;

  const cmpDataOriginal = window.__cmp('getCMPData');
  if (!cmpDataOriginal?.vendorConsents) {
    return;
  }

  serviceEnabled = cmpDataOriginal.vendorConsents[IAB_VENDOR_ID];

  // https://help.consentmanager.net/books/cmp/page/cmp-events
  window.__cmp('addEventListener', ['consentcustom', () => {
    const cmpData = window.__cmp('getCMPData');
    if (!cmpData?.vendorConsents) {
      return;
    }

    const serviceEnabledNew = cmpData.vendorConsents[IAB_VENDOR_ID];
    if (serviceEnabledNew === serviceEnabled) {
      return;
    }

    serviceEnabled = serviceEnabledNew;
    if (!serviceEnabled) {
      subscriptionManager.unsubscribe(true);
    }
  }, false], null);
};

const initTcf = (subscriptionManager) => {
  if (typeof window.__tcfapi === 'function' && typeof window.UC_UI === 'object') {
    initUserCentrics(subscriptionManager);
  } else if (typeof window.__tcfapi === 'function' && typeof window.__cmp === 'function') {
    initConsentManager(subscriptionManager);
  }
};

export default initTcf;
